import Service from '../invoice-pro-service.js';
const debounce = require('lodash.debounce');
import { successMessage, errorMessage } from '@/utils/message.js';
import RegExp from '@/utils/regExp.js';
export default {

  data() {
    return {
      disabled: true,
      userType: '',
      query: {},
      form: {
        invoiceType: 1,
        email: '',
        remark: ''
      },
      rules: {
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change'}],
        email: [{required: true, pattern: RegExp.email, message: '请输入电子邮箱', trigger: 'blur'}]
      }
    };
  },
  created() {
    this.query = this.$route.query;
    this.getInvoiceInfo();
  },
  computed: {
  },
  methods: {
    getInvoiceInfo() {
      Service.getInvoiceInfo(this.query.bidId).then(res => {
        if (res && res.code === '0') {
          if (res.data) {
            for (let item in res.data) {
              this.form[item] = res.data[item];
            }
          }
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 提交信息
    sendInfo() {
      Service.sendInfo({...this.form, ...this.query}).then(res => {
        if (res && res.code === '0') {
          successMessage('提交成功');
          this.$router.push('/person-center/invoice-pro/list');
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    submit: debounce(function() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$confirm('是否继续提交信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.sendInfo();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    })
  }
};
